import { useEffect } from "react";
import { useNavigation } from "@/context/NavigationContext"; // Import your custom context
import { Button } from "@/components/ui/button";
import { FileQuestion } from "lucide-react";

const NotFound = () => {
  const { page, navigateTo } = useNavigation();

  useEffect(() => {
    // Log the state-name that caused the fallback instead of a URL path
    console.error("404 Error: App reached an undefined state:", page);
  }, [page]);

  return (
    <div className="flex min-h-[80vh] items-center justify-center animate-fade-in">
      <div className="text-center space-y-6 aviation-glass p-12 rounded-[2rem] border border-border/50 shadow-2xl">
        <div className="relative inline-block">
          <FileQuestion className="h-20 w-20 mx-auto text-orange-500/50" />
          <h1 className="absolute inset-0 flex items-center justify-center text-4xl font-black italic tracking-tighter text-white">
            404
          </h1>
        </div>

        <div className="space-y-2">
          <h2 className="text-2xl font-display font-bold text-white">Eroare de Navigație</h2>
          <p className="text-muted-foreground max-w-xs mx-auto">
            Pagina solicitată nu a putut fi găsită în sistemul HangarX.
          </p>
        </div>

        <Button
          onClick={() => navigateTo("home")}
          className="bg-primary text-primary-foreground hover:bg-primary/90 font-display font-semibold px-8"
        >
          Înapoi la Acasă
        </Button>
      </div>
    </div>
  );
};

export default NotFound;